const SiteReferrerEvent = {
  fetchSiteReferrers: 'site-referrer/fetch-site-referrers',
  fetchAll: 'site-referrer/fetch-all'
}

export default SiteReferrerEvent
